module.exports = __webpack_public_path__ + "img/logo.c6cae89c.png";